// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = typeof window == 'object' && window && window.Math == Math ? window
  : typeof self == 'object' && self && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();



//////////////////
// WEBPACK FOOTER
// ../node_modules/@firebase/polyfill/node_modules/core-js/internals/global.js
// module id = 23
// module chunks = 16